/* eslint-disable no-console */
import { atom, selector } from 'recoil';

export type JSObject = { [key: string]: unknown };

// Extend window interface for _amplitudeClient
declare global {
  interface Window {
    _amplitudeClient: IAmplitudeClient;
  }
}

export enum EVENTS {
  SHARED_PRIVATE_FEEDBACK = 'Rated Provider Privately',
  SHARED_PROVIDER_PRIVATE_FEEDBACK = 'Rated Buyer Privately',
  CONSIDERED_LEAVING_PRIVATE_FEEDBACK = 'Considered Leaving Private Feedback',
  LEFT_PRIVATE_FEEDBACK = 'Left Private Feedback',
}

export interface IEventProps extends JSObject {
  Source?: string;
  'Work Order ID'?: number;
  'Work Order Status'?: string;
  'Provider ID'?: number;
  'Company ID'?: number;
  Version?: string;
  'Previously Reviewed'?: string;
  'Overall Service'?: string;
  'Left Comment'?: string;
  Comment?: string;
  Question?: string;
  Score?: number | null;
  'Has Comment'?: string;
  Attributes?: (string | undefined)[];
  'Nothing Stood Out'?: string;
  'Left Stand Out Attributes'?: string;
  'Left Areas For Improvement'?: string;
  'Stand Out Attributes'?: (string | undefined)[];
  'Areas For Improvement'?: (string | undefined)[];
}

export type ITrackEvent = (
  eventType: EVENTS | string,
  eventProperties: IEventProps,
  callback?: () => void,
) => number | undefined;

export const defaultTracker: ITrackEvent = (
  eventType: EVENTS | string,
  eventProperties: IEventProps,
  callback?: () => void,
) => {
  console.warn(`Failed to setup Amplitude. Event [${eventType}]`, {
    eventProperties,
    callback,
  });
  return undefined;
};

export interface IAmplitudeClient {
  logEvent: ITrackEvent;
}

class AmplitudeClient {
  public logEvent: ITrackEvent = defaultTracker;
}

export const AmplitudeClientAtom = atom<IAmplitudeClient>({
  key: 'PrivateFeedbackAmplitudeClientAtom',
  default: new AmplitudeClient(),
});

export const EventTrackerSelector = selector({
  key: 'PrivateFeedbackEventTrackerSelector',
  get: ({ get }) => {
    // eslint-disable-next-line no-underscore-dangle
    const windowClient = window._amplitudeClient;
    const amplitudeClient = windowClient || get(AmplitudeClientAtom);

    return (
      eventType: EVENTS | string,
      eventProperties: IEventProps,
      callback?: () => void,
    ) => amplitudeClient?.logEvent(eventType, eventProperties, callback);
  },
});
